import { css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import dataOffer from './offers.js';
import assetsPath from '../../constant.js';

interface OfferData {
  offer: string;
  children: (Record<string, string> | Record<string, boolean>)[];
}

/**
 * Nordnet Horizontal Subvention Block atom. Used standalone.
 *
 * offer - The offer. (required, i.e. SAT_PRO, 4G_FIX, SAT, RADIO)
 * context - The context. (optional, i.e. in-page, in-modal)
 */
@customElement('nn-horizontal-subvention-block')
export class horizontalSubventionBlock extends LitElement {
  static styles = css`
    .modal-subvention-block * {
      box-sizing: border-box;
      margin: 0;
      padding: 0;
    }

    .modal-subvention-block {
      background: var(
        --nn-horizontal-subvention-block_modal-subvention-block_background,
        #fff
      );
    }

    .modal-subvention-block .subtitle-02 {
      color: var(
        --nn-horizontal-subvention-block_modal-subvention-block_subtitle-02_color,
        #000
      );
      font-family: 'font-heavy';
      font-size: var(
        --nn-horizontal-subvention-block_modal-subvention-block_subtitle-02_font-size,
        24px
      );
      line-height: calc(2ex + 4px);
    }

    .modal-subvention-block .heading-01 {
      align-items: center;
      color: var(
        --nn-horizontal-subvention-block_modal-subvention-block_heading-01_color,
        #000
      );
      display: flex;
      font-family: 'font-heavy';
      font-size: var(
        --nn-horizontal-subvention-block_modal-subvention-block_heading-01_font-size,
        48px
      );
      gap: var(
        --nn-horizontal-subvention-block_modal-subvention-block_heading-01_gap,
        16px 0
      );
      justify-content: center;
      line-height: calc(4px + 2ex);
    }

    .modal-subvention-block .heading-01 small {
      color: var(
        --nn-horizontal-subvention-block_modal-subvention-block_heading-01_small_color,
        #686868
      );
      font-size: var(
        --nn-horizontal-subvention-block_modal-subvention-block_heading-01_small_font-size,
        28px
      );
      line-height: 1;
    }

    .modal-subvention-block .heading-04 {
      align-items: center;
      color: var(
        --nn-horizontal-subvention-block_modal-subvention-block_heading-04_color,
        #000
      );
      display: flex;
      font-family: 'font-light';
      font-size: var(
        --nn-horizontal-subvention-block_modal-subvention-block_heading-04_font-size,
        24px
      );
      justify-content: center;
      line-height: calc(4px + 2ex);
    }

    .modal-subvention-block .subtitle-01 {
      color: var(
        --nn-horizontal-subvention-block_modal-subvention-block_subtitle-01_color,
        #000
      );
      font-family: 'font-heavy';
      font-size: var(
        --nn-horizontal-subvention-block_modal-subvention-block_subtitle-01_font-size,
        24px
      );
      line-height: calc(2ex + 4px);
      padding: var(
        --nn-horizontal-subvention-block_modal-subvention-block_subtitle-01_padding,
        20px 0
      );
    }
    .modal-subvention-block .subtitle-02 {
      align-items: center;
      color: var(
        --nn-horizontal-subvention-block_modal-subvention-block_subtitle-02_color,
        #000
      );
      background: var(
        --nn-horizontal-subvention-block_modal-subvention-block_subtitle-02_background,
        #fff
      );
      border-radius: var(
        --nn-horizontal-subvention-block_modal-subvention-block_subtitle-02_border-radius,
        24px
      );
      display: inline-flex;
      font-family: 'font-heavy';
      font-size: var(
        --nn-horizontal-subvention-block_modal-subvention-block_subtitle-02_font-size,
        28px
      );
      height: var(
        --nn-horizontal-subvention-block_modal-subvention-block_subtitle-02_height,
        120px
      );
      justify-content: center;
      line-height: calc(2ex + 4px);
      margin: var(
        --nn-horizontal-subvention-block_modal-subvention-block_subtitle-02_margin,
        0 0 8px 0
      );
      padding: var(
        --nn-horizontal-subvention-block_modal-subvention-block_subtitle-02_padding,
        24px
      );
      text-align: center;
      width: 100%;
    }
    .modal-subvention-block .paragraph-01 {
      color: var(
        --nn-horizontal-subvention-block_modal-subvention-block_paragraph-01_color,
        #686868
      );
      font-family: 'font-light';
      font-size: var(
        --nn-horizontal-subvention-block_modal-subvention-block_paragraph-01_font-size,
        20px
      );
      line-height: calc(2ex + 4px);
    }
    .modal-subvention-block .paragraph-01 + .first {
      margin-top: var(
        --nn-horizontal-subvention-block_modal-subvention-block_paragraph-01-first_margin-top,
        16px
      );
    }
    .modal-subvention-block * b {
      font-family: 'font-heavy';
      font-weight: normal;
    }

    .modal-subvention-block .paragraph-01 b {
      color: var(
        --nn-horizontal-subvention-block_modal-subvention-block_paragraph-01_b_color,
        #000
      );
    }
    .modal-subvention-block .generic-block {
      border: var(
        --nn-horizontal-subvention-block_modal-subvention-block_generic-block_border,
        0
      );
      border-radius: var(
        --nn-horizontal-subvention-block_modal-subvention-block_generic-block_border-radius,
        0
      );
      background: var(
        --nn-horizontal-subvention-block_modal-subvention-block_generic-block_background,
        none
      );
      margin: var(
        --nn-horizontal-subvention-block_modal-subvention-block_generic-block_margin,
        0 0 24px
      );
      padding: var(
        --nn-horizontal-subvention-block_modal-subvention-block_generic-block_padding,
        0
      );
    }
    .modal-subvention-block .custom-flex {
      align-items: center;
      background: var(
        --nn-horizontal-subvention-block_modal-subvention-block_custom-flex_background,
        #fff
      );
      border-radius: var(
        --nn-horizontal-subvention-block_modal-subvention-block_custom-flex_border-radius,
        24px
      );
      display: flex;
      flex-wrap: wrap;
      gap: var(
        --nn-horizontal-subvention-block_modal-subvention-block_custom-flex_gap,
        16px
      );
      height: var(
        --nn-horizontal-subvention-block_modal-subvention-block_custom-flex_height,
        145px
      );
      justify-content: center;
    }
    .modal-subvention-block .custom-flex--column {
      flex-basis: auto;
      flex-shrink: 0;
      width: var(
        --nn-horizontal-subvention-block_modal-subvention-block_custom-flex--column_width,
        calc(50% - 8px)
      );
    }
    .modal-subvention-block .mentions {
      color: var(
        --nn-horizontal-subvention-block_modal-subvention-block_mentions_color,
        #686868
      );
      font-family: 'font-light';
      font-size: var(
        --nn-horizontal-subvention-block_modal-subvention-block_mentions_font-size,
        16px
      );
      line-height: calc(2ex + 4px);
      padding: var(
        --nn-horizontal-subvention-block_modal-subvention-block_mentions_padding,
        0 0 24px
      );
      text-align: center;
      width: var(
        --nn-horizontal-subvention-block_modal-subvention-block_mentions_width,
        100%
      );
    }
    .modal-subvention-block .alternate-block {
      align-items: center;
      background: var(
        --nn-horizontal-subvention-block_modal-subvention-block_alternate-block_background,
        #494949
      );
      border-radius: var(
        --nn-horizontal-subvention-block_modal-subvention-block_alternate-block_border-radius,
        50%
      );
      color: var(
        --nn-horizontal-subvention-block_modal-subvention-block_alternate-block_color,
        #fff
      );
      display: inline-flex;
      flex-basis: auto;
      flex-shrink: 0;
      font-family: 'font-medium';
      font-size: var(
        --nn-horizontal-subvention-block_modal-subvention-block_alternate-block_font-size,
        20px
      );
      height: var(
        --nn-horizontal-subvention-block_modal-subvention-block_alternate-block_height,
        45px
      );
      justify-content: center;
      margin: var(
        --nn-horizontal-subvention-block_modal-subvention-block_alternate-block_margin,
        0 25px 25px
      );
      text-transform: uppercase;
      width: var(
        --nn-horizontal-subvention-block_modal-subvention-block_alternate-block_width,
        45px
      );
    }
    .modal-subvention-block .first .custom-flex {
      background: none;
      border-radius: var(
        --nn-horizontal-subvention-block_modal-subvention-block_first_custom-flex_border-radius,
        0
      );
      height: var(
        --nn-horizontal-subvention-block_modal-subvention-block_first_custom-flex_height,
        auto
      );
    }
    .modal-subvention-block .first {
      flex-basis: auto;
      flex-shrink: 0;
      width: var(
        --nn-horizontal-subvention-block_modal-subvention-block_first_width,
        calc((50% - 23px) - (48px / 2))
      );
    }
    .modal-subvention-block .second {
      flex-basis: auto;
      flex-shrink: 0;
      width: var(
        --nn-horizontal-subvention-block_modal-subvention-block_second_width,
        calc((50% - 23px) - (48px / 2))
      );
    }
    .modal-subvention-block .first .custom-flex--column {
      align-items: center;
      background: var(
        --nn-horizontal-subvention-block_modal-subvention-block_first_custom-flex--column_background,
        #fff
      );
      border-radius: var(
        --nn-horizontal-subvention-block_modal-subvention-block_first_custom-flex--column_border-radius,
        24px
      );
      display: inline-flex;
      flex-direction: column;
      height: var(
        --nn-horizontal-subvention-block_modal-subvention-block_first_custom-flex--column_height,
        145px
      );
      justify-content: center;
      width: var(
        --nn-horizontal-subvention-block_modal-subvention-block_first_custom-flex--column_width,
        100%
      );
    }
    .modal-subvention-block--content {
      align-items: center;
      display: flex;
      justify-content: center;
      gap: var(
        --nn-horizontal-subvention-block_modal-subvention-block--content_gap,
        24px
      );
    }
    .in-page .subtitle-01 {
      font-size: var(
        --nn-horizontal-subvention-block_in-page_subtitle-01,
        40px
      );
      padding: var(
        --nn-horizontal-subvention-block_in-page--subtitle-01_padding,
        32px 0 48px
      );
      text-align: center;
    }
    .in-page.modal-subvention-block,
    .in-modal.modal-subvention-block .first .custom-flex--column,
    .in-modal.modal-subvention-block .second .custom-flex {
      background: var(
        --nn-horizontal-subvention-block_blocks_background,
        #f6f6f6
      );
    }
    .in-modal.modal-subvention-block .first .custom-flex--column,
    .in-modal.modal-subvention-block .second .custom-flex {
      border: 1px solid
        var(--nn-horizontal-subvention-block_blocks_border-color, #efefef);
    }
    .in-modal.modal-subvention-block .first .custom-flex--column,
    .in-modal.modal-subvention-block .second .custom-flex {
      height: var(--nn-horizontal-subvention-block_blocks_height, auto);
      min-height: var(
        --nn-horizontal-subvention-block_blocks_min-height,
        120px
      );
    }
    .in-modal.modal-subvention-block,
    .in-page.modal-subvention-block .first .custom-flex--column,
    .in-page.modal-subvention-block .second .custom-flex {
      background: var(
        --nn-horizontal-subvention-block_blocks_inverted_background,
        #fff
      );
    }
    .in-modal.modal-subvention-block .heading-01 {
      font-size: var(
        --nn-horizontal-subvention-block_in-modal-modal-subvention-block_heading-01_font-size,
        32px
      );
    }
    .in-modal .modal-subvention-block--content .subtitle-02 {
      background: var(
        --nn-horizontal-subvention-block_in-modal_modal-subvention-block_subtitle-02_background,
        #f6f6f6
      );
      border: 1px solid
        var(
          --nn-horizontal-subvention-block_in-modal_modal-subvention-block_subtitle-02_border-color,
          #efefef
        );
      font-size: var(
        --nn-horizontal-subvention-block_in-modal_modal-subvention-block_subtitle-02_font-size,
        18px
      );
      height: var(
        --nn-horizontal-subvention-block_in-modal_modal-subvention-block_subtitle-02_height,
        auto
      );
    }
    .in-modal .modal-subvention-block--content {
      flex-direction: column;
      gap: var(
        --nn-horizontal-subvention-block_in-modal_modal-subvention-block--content_gap,
        0
      );
    }
    .in-modal.modal-subvention-block .first,
    .in-modal.modal-subvention-block .second {
      width: var(
        --nn-horizontal-subvention-block_in-modal_modal-subvention-block_ordered_width,
        100%
      );
    }
    .in-modal .modal-subvention-block--content .heading-01 {
      font-size: var(
        --nn-horizontal-subvention-block_in-modal_modal-subvention-block--content_heading-01_font-size,
        32px
      );
    }
    .in-modal .modal-subvention-block--content .heading-01 small {
      font-size: var(
        --nn-horizontal-subvention-block_in-modal_modal-subvention-block--content_heading-01_small_font-size,
        18px
      );
    }
    .in-modal.modal-subvention-block .heading-04 {
      font-size: var(
        --nn-horizontal-subvention-block_in-modal_modal-subvention-block--content_heading-04_font-size,
        20px
      );
    }
    @media (max-width: 1499px) {
      :host {
        --nn-horizontal-subvention-block_modal-subvention-block_heading-01_font-size: 36px;
        --nn-horizontal-subvention-block_modal-subvention-block_heading-01_small_font-size: 20px;
        --nn-horizontal-subvention-block_modal-subvention-block_subtitle-02_font-size: 24px;
        --nn-horizontal-subvention-block_in-modal_modal-subvention-block--content_heading-01_small_font-size: 18px;
      }
    }
    @media (max-width: 991px) {
      :host {
        --nn-horizontal-subvention-block_in-modal_modal-subvention-block--content_gap: 16px;
      }
      .modal-subvention-block--content .generic-block {
        margin: var(
          --nn-horizontal-subvention-block_modal-subvention-block--content_generic-block_margin,
          0
        );
      }
      .modal-subvention-block--content {
        flex-direction: column;
      }
      .modal-subvention-block--content .first,
      .modal-subvention-block--content .second {
        max-width: var(
          --nn-horizontal-subvention-block_modal-subvention-block--content_ordered_max-width,
          100%
        );
        width: var(
          --nn-horizontal-subvention-block_modal-subvention-block--content_ordered_width,
          600px
        );
      }
      .modal-subvention-block--content .alternate-block {
        margin: var(
          --nn-horizontal-subvention-block_modal-subvention-block--content_alternate-block_margin,
          0
        );
      }
      .modal-subvention-block--content .subtitle-02 {
        border-radius: var(
          --nn-horizontal-subvention-block_modal-subvention-block--content_subtitle-02_border-radius,
          16px
        );
        height: var(
          --nn-horizontal-subvention-block_modal-subvention-block--content_subtitle-02_height,
          auto
        );
        padding: var(
          --nn-horizontal-subvention-block_modal-subvention-block--content_subtitle-02_padding,
          16px
        );
      }
      .modal-subvention-block--content .custom-flex {
        border-radius: var(
          --nn-horizontal-subvention-block_modal-subvention-block--content_custom-flex_border-radius,
          16px
        );
        height: var(
          --nn-horizontal-subvention-block_modal-subvention-block--content_custom-flex_height,
          auto
        );
        padding: var(
          --nn-horizontal-subvention-block_modal-subvention-block--content_custom-flex_padding,
          16px
        );
      }
      .modal-subvention-block--content .first .custom-flex {
        padding: var(
          --nn-horizontal-subvention-block_modal-subvention-block--content_first_custom-flex_padding,
          0
        );
      }
      .modal-subvention-block--content .first .custom-flex--column {
        height: var(
          --nn-horizontal-subvention-block_modal-subvention-block--content_first_custom-flex--column_height,
          auto
        );
        padding: var(
          --nn-horizontal-subvention-block_modal-subvention-block--content_first_custom-flex--column_padding,
          24px 16px
        );
      }
      .modal-subvention-block--content + .mentions {
        padding-top: var(
          --nn-horizontal-subvention-block_modal-subvention-block__mentions_padding-top,
          24px
        );
      }
    }
    @media (max-width: 767px) {
      :host {
        --nn-horizontal-subvention-block_modal-subvention-block_custom-flex--column_width: 100%;
        --nn-horizontal-subvention-block_modal-subvention-block_subtitle-02_font-size: 18px;
        --nn-horizontal-subvention-block_modal-subvention-block_heading-01_font-size: 28px;
        --nn-horizontal-subvention-block_modal-subvention-block_heading-01_gap: 8px
          0;
        --nn-horizontal-subvention-block_in-page_subtitle-01_font-size: 24px;
        --nn-horizontal-subvention-block_in-page_subtitle-01_padding: 28px 0
          20px;
        --nn-horizontal-subvention-block_modal-subvention-block_heading-01_small_font-size: 24px;
        --nn-horizontal-subvention-block_modal-subvention-block_heading-04_font-size: 20px;
        --nn-horizontal-subvention-block_in-page_subtitle-01: 24px;
      }
      .modal-subvention-block .custom-flex--column {
        align-items: center;
        display: inline-flex;
        flex-wrap: wrap;
        justify-content: center;
        text-align: center;
      }
      .modal-subvention-block .second .custom-flex--column:first-child {
        margin: var(
          --nn-horizontal-subvention-block_modal-subvention-block_second_custom-flex--column--first-child_margin,
          12px 0 8px
        );
      }
      .modal-subvention-block .subtitle-02,
      .modal-subvention-block .heading-01 {
        text-align: center;
      }
      .modal-subvention-block .heading-04 {
        flex-basis: auto;
        flex-shrink: 0;
        width: 100%;
      }
      .in-modal .heading-01 {
        font-size: var(
          --nn-horizontal-subvention-block_in-modal_heading-01_font-size,
          28px
        );
      }
      .in-modal.modal-subvention-block .heading-01 small {
        font-size: 18px;
      }
      .in-modal .modal-subvention-block--content .subtitle-02,
      .in-modal.modal-subvention-block .heading-04 {
        font-size: var(
          --nn-horizontal-subvention-block_in-modal_modal-subvention-block_titles,
          18px
        );
      }
    }
    @media (max-width: 479px) {
      :host {
        --nn-horizontal-subvention-block_modal-subvention-block_heading-01_font-size: 30px;
        --nn-horizontal-subvention-block_modal-subvention-block_heading-01_small_font-size: 20px;
        --nn-horizontal-subvention-block_modal-subvention-block_subtitle-02_font-size: 24px;
      }
      .modal-subvention-block .heading-01 {
        text-align: center;
      }
    }
  `;

  @property({ type: String }) offer = 'SAT';

  @property({ type: String }) context = '';

  render() {
    const offers = JSON.parse(
      JSON.stringify(dataOffer).replace(/<prefixPath>/g, assetsPath)
    );
    const selectedOffer = offers.find(
      (offer: OfferData) => offer.offer === this.offer
    );
    return html`
      <div class="modal-subvention-block ${selectedOffer} ${this.context}">
        ${this.renderLogo()} ${this.renderEscape(selectedOffer)}
        ${this.renderSubtitle(selectedOffer)}
        <div class="modal-subvention-block--content">
          <div class="generic-block first">
            <p
              class="subtitle-02"
              .innerHTML="${selectedOffer.children[0].block01Title}"
            ></p>
            <div class="custom-flex">
              <p
                class="custom-flex--column"
                .innerHTML="${selectedOffer.children[0].block01column01Text}"
              ></p>
            </div>
          </div>
          ${this.renderSecondBlock(selectedOffer)}
        </div>
        <p
          class="mentions"
          .innerHTML="${selectedOffer.children[0].blockMentions}"
        ></p>
      </div>
    `;
  }

  renderEscape = (selectedOffer: OfferData) => {
    if (selectedOffer.offer === 'RADIO' || selectedOffer.offer === 'SAT_PRO') {
      return html` <br /> `;
    }
    return '';
  };

  renderLogo = () => {
    if (this.context === 'in-modal') {
      return html`
        <div>
          <img
            width="229"
            height="76"
            src="${assetsPath}/images/modal/subvention/france-tres-haut-debit-logo.svg"
            alt="Plan France Très Haut Débit"
            loading="lazy"
          />
        </div>
      `;
    }
    return '';
  };

  renderSubtitle = (selectedOffer: OfferData) => {
    const subTitle = selectedOffer.children[0].subtitle;
    if (subTitle) {
      return html`
        <p
          class="subtitle-01"
          .innerHTML="${selectedOffer.children[0].subtitle}"
        ></p>
      `;
    }
    return '';
  };

  renderSecondBlock = (selectedOffer: OfferData) => {
    const secondBlock = selectedOffer.children[0].block02;
    if (secondBlock === true) {
      return html`
        <p class="alternate-block">ou</p>
        <div class="generic-block second">
          <p
            class="subtitle-02"
            .innerHTML="${selectedOffer.children[0].block02Title}"
          ></p>
          <div class="custom-flex">
            <p
              class="custom-flex--column"
              .innerHTML="${selectedOffer.children[0].block02column01Text}"
            ></p>
            <p
              class="custom-flex--column"
              .innerHTML="${selectedOffer.children[0].block02column02Text}"
            ></p>
          </div>
        </div>
      `;
    }
    return '';
  };

  parseHtml = (str?: any) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(str, 'text/html');
    return doc.body;
  };
}
